import axios from "axios"

export function getStockoutDetail (id) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/stockout/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};